module.exports = __webpack_public_path__ + "img/postnl_payment.5df7fd02.svg";